import React from 'react';
import _ from 'lodash';
import messages from '../../../../const/messages';
import withClickOutsideOnOverlay from '../../../../hoc/withClickOutsideOnOverlay';
import nextBtnOptionNameGenerator from '../../../../services/mini/nextBtnOptionNameGenerator';
import cancelEvent from '../../../../services/mini/cancelEvent';
import {FormWithCancelButton} from '../../../forms/FormWithCancelButton';
import BasicFormWithValidation from '../../../forms/BasicFormWithValidation';

class NewButtonOptionsForm extends FormWithCancelButton {

    getSuggestedComment = () => {
        const { savedOptions } = this.props;
        return nextBtnOptionNameGenerator(savedOptions.map(el => el.name));
    }

    validateComment = ({ comment }) => {
        const { savedOptions } = this.props;

        if (!comment) {
            return 'Enter comment';
        }

        if (_.find(savedOptions, { name: comment })) {
            return messages.commentAlreadyExists;
        }

        return null;
    }

    ok = ({ comment }) => {
        this.props.addButtonOptions({ name: comment });
        this.props.onClose();
    }

    onExternalLayerClick = (e) => {
        if (e.target.classList.contains('new-btn-options-form-overlay')) {
            this.props.onClose(e);
        } else {
            cancelEvent(e);
        }
    }

    render() {
          //todo: recheck form
        return (
            <div className="new-btn-options-form-overlay"
                onClick={this.onExternalLayerClick}>
                <BasicFormWithValidation
                    title="Save Button Options"
                    inputs={[{
                        name: 'comment',
                        label: 'Comment',
                        autoFocus: true,
                        maxLength: 50,
                        maxLengthMsg: `Max comment name length: 50 characters`,
                        value: this.getSuggestedComment(),
                        rules: [this.validateComment],
                        applyOnEnter: true
                    }]}
                    okButton={{
                        label: 'Save',
                        action: this.ok
                    }}
                    cancelButton={{
                        label: 'Cancel',
                        action: this.cancel,
                    }}
                    enableActionBtnByDefault={true}
                />;
            </div>
        );
    }
}

export default withClickOutsideOnOverlay(NewButtonOptionsForm);